import React from "react";
import { useNavigate } from "react-router-dom";
import { KbAdminView } from "@nrgpix/kb";

/** Sustina's page around the shared @nrgpix/kb management screen (KBADMIN only). */
export default function KnowledgeBaseAdminPage() {
    const navigate = useNavigate();
    return (
        <main id="main" className="page-main" data-scroll-container>
            <div className="page-main-inner">
                <section className="page-section">
                    <div className="container mt-4">
                        <h2 className="h4 fw-bold mb-1">Knowledge Base</h2>
                        <p className="text-muted small mb-4">
                            The guidance, standards and policies everyone can search from the
                            Knowledge Base panel while they report.
                        </p>
                        <KbAdminView />
                        <div className="mt-5 pt-4 border-top">
                            <button
                                className="btn btn-link text-decoration-none p-0 text-secondary small"
                                onClick={() => navigate("/registered/dashboard")}
                            >
                                <i className="bi bi-arrow-left me-2"></i> Return to Dashboard
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
}
